import {
  EtapeScenario,
  IEtapeScenario,
  IEtapeScenarioLight,
} from './EtapeScenario';
import { BaseObject, IBaseObject } from './BaseObject';
import { ISagtFeature } from './SagtFeature';
import { EsriHelpers } from '../_helpers/EsriHelpers';

export interface IActivationSp {
  id: number | string;
  actif: boolean;
  etapes: IEtapeScenarioLight[];
}

export interface IScenarioPreprogramme extends IBaseObject {
  nom: string;
  actif: boolean;
  idType?: number;
  descriptionType?: string;
  etapes: IEtapeScenario[];
  features: ISagtFeature[];
  etapesActives?: string;
}

export class ScenarioPreprogramme
  extends BaseObject
  implements IScenarioPreprogramme
{
  nom = '';
  actif = false;
  idType?: number;
  descriptionType?: string;
  etapesActives?: string;
  etapes: EtapeScenario[] = [];
  features: ISagtFeature[] = [];

  constructor(props?: IScenarioPreprogramme) {
    super(props);

    if (props) {
      this.nom = props.nom;
      this.actif = props.actif;
      this.idType = props.idType;
      this.descriptionType = props.descriptionType;
      this.etapesActives = props.etapesActives;
      if (props.etapes) {
        this.etapes = props.etapes.map((x) => new EtapeScenario(x));
      }
      if (props.features) {
        this.features = props.features.map((x) => Object.assign({}, x));
      }
    }
  }

  public format(): IScenarioPreprogramme {
    const item: IScenarioPreprogramme = {
      id: this.id,
      etapes: this.etapes.map((x) => x.format(this.id)),
      features: this.features.map((x) => {
        const f = Object.assign({}, x);
        f.color = EsriHelpers.rgbaStringToHexString(x.color);
        return f;
      }),
      nom: this.nom,
      idType: this.idType,
      actif: this.actif,
    };

    if (item.id == null || item.id === -1) {
      // @ts-ignore
      delete item.id;
    }

    return item;
  }
}
